import MethodologyModal from './MethodologyModal'

export default MethodologyModal
